import {getSanityClient} from './sanityClient'

const postProjection = `{
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  excerpt,
  featuredImage,
  body
}`

export const ALL_POSTS_QUERY = `*[_type == "post" && defined(slug.current)] | order(coalesce(publishedAt, _updatedAt) desc) ${postProjection}`

export const POST_BY_SLUG_QUERY = `*[_type == "post" && slug.current == $slug][0] ${postProjection}`

export async function getAllPosts() {
  const client = getSanityClient()
  if (!client) return []
  return client.fetch(ALL_POSTS_QUERY)
}

export async function getPostBySlug(slug) {
  const client = getSanityClient()
  if (!client) return null
  return client.fetch(POST_BY_SLUG_QUERY, {slug})
}
